import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import authSaga from "./features/auth/auth-saga";
import usersSaga from "./features/users/users-saga";
import userSaga from "./features/user/user-saga";
import trainersSaga from "./features/trainers/trainers-saga";
import trainerSaga from "./features/trainer/trainer-saga";
import rootReducer from "./rootReducer";
import { RootState } from "./rootReducer";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import exercisesSaga from "./features/exercises/exercises-saga";
import exerciseSaga from "./features/exercise/exercise-saga";
import altExerciseSaga from "./features/exercise/alt-exercises-saga";
import trainingProgramsSaga from "./features/training-programs/training-programs-saga";
import trainingProgramSaga from "./features/training-program/training-program-saga";
import workoutsSaga from "./features/workouts/workouts-saga";
import workoutSaga from "./features/workout/workout-saga";
import vodsSaga from "./features/vods/vods-saga";
import vodSaga from "./features/vod/vod-saga";
import recipesSaga from "./features/recipes/recipes-saga";
import recipeSaga from "./features/recipe/recipe-saga";
import userTrainingProgramsSaga from "./features/user/training-programs/training-programs-saga";
import dashboardStatsSaga from "./features/dashboard/stats/stats-saga";
import dashboardActiveUsersSaga from "./features/dashboard/active-users/active-users-saga";
import dashboardRevenuesSaga from "./features/dashboard/revenues/revenues-saga";

const saga = createSagaMiddleware();
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(saga),
});

saga.run(authSaga);
saga.run(usersSaga);
saga.run(userSaga);
saga.run(trainersSaga);
saga.run(trainerSaga);
saga.run(exercisesSaga);
saga.run(exerciseSaga);
saga.run(trainingProgramsSaga);
saga.run(trainingProgramSaga);
saga.run(workoutsSaga);
saga.run(workoutSaga);
saga.run(vodsSaga);
saga.run(vodSaga);
saga.run(recipesSaga);
saga.run(recipeSaga);
saga.run(userTrainingProgramsSaga);
saga.run(dashboardStatsSaga);
saga.run(dashboardActiveUsersSaga);
saga.run(dashboardRevenuesSaga);
saga.run(altExerciseSaga);

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export default store;
